export default __webpack_public_path__ + "static/floor1_image3-sp-ed4ac201055fc2bc94532084a7493dff.png";